import React from "react";

import { Interpolate } from "@/mk2/components/Interpolate";
import { BAZAAR_TRANSACTION_BLOCK_NOT_ALLOWED_username } from "@/mk/autogenerated/translations/BazaarBlockNotAllowed.27a0bdc0b84fbb9c2c01ef052dc4404d";

// FAQ contact form pre-filled with the "message to admin" topic. Relative path so
// it works on both the SK (.sk) and CZ (.cz) domains.
const FAQ_ADMIN_FORM_URL = "/faq/form/?faq=message-mk";

interface Props {
    username: string;
}

export const BazaarBlockNotAllowed: React.FunctionComponent<Props> = React.memo(({ username }) => (
    <Interpolate
        i18nKey={BAZAAR_TRANSACTION_BLOCK_NOT_ALLOWED_username}
        username={username}
        components={[<a key="link" data-google-interstitial="false" href={FAQ_ADMIN_FORM_URL} />]}
    />
));

BazaarBlockNotAllowed.displayName = "BazaarBlockNotAllowed";

export function BazaarBlockNotAllowedToast(username: string) {
    return <BazaarBlockNotAllowed username={username} />;
}
